module.exports = __webpack_public_path__ + "44aee20909d714bad97994251294c746.webm";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/videos/cnn-richard-prince.webm
 ** module id = 351
 ** module chunks = 0
 **/